exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_pageBanners__1DkZ_{display:flex;flex-direction:column;background-color:#fff}.style_warning__luMpL{width:100%;text-align:center}", ""]);

// exports
exports.locals = {
	"pageBanners": "style_pageBanners__1DkZ_",
	"warning": "style_warning__luMpL"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/SystemMessagesBanner/style.less
// module id = 2010
// module chunks = 8